export const adminTokens = {
  colors: {
    midnight: "#031D36",
    deepNavy: "#062B4F",
    royalBlue: "#075EA8",
    electricBlue: "#0B7CFF",
    garahexOrange: "#FF6B00",
    warmOrange: "#FF8A1F",
    success: "#16B364",
    warning: "#F5A524",
    danger: "#F04438",
    purple: "#7C5CFC",
    cyan: "#16B8D4",
    workspace: "#F4F8FC",
    surface: "#FFFFFF",
    text: "#08223D",
    muted: "#5F7388",
    border: "rgba(8, 34, 61, 0.12)"
  },
  layout: {
    sidebarExpanded: 208,
    sidebarCollapsed: 62,
    headerHeight: 56,
    contentMaxWidth: 1680
  },
  density: {
    fontBody: "0.84rem",
    fontMeta: "0.72rem",
    fontCaption: "0.68rem",
    sectionTitle: "1rem",
    pageTitle: "clamp(1.38rem, 1.55vw, 1.62rem)",
    pagePaddingX: "clamp(14px, 1.55vw, 20px)",
    cardPadding: "clamp(14px, 1.2vw, 18px)",
    sectionGap: 16,
    controlHeight: 36,
    controlHeightSmall: 32,
    tableRowHeight: 40,
    tableCellPadding: "7px 10px",
    iconSize: 18
  },
  radius: {
    sm: 7,
    md: 10,
    lg: 14,
    xl: 18,
    pill: 999
  },
  shadows: {
    card: "0 12px 32px rgba(3, 29, 54, 0.09)",
    elevated: "0 18px 52px rgba(3, 29, 54, 0.16)",
    focus: "0 0 0 4px rgba(11, 124, 255, 0.22)"
  },
  motion: {
    fast: "140ms cubic-bezier(.2, .8, .2, 1)",
    base: "190ms cubic-bezier(.2, .8, .2, 1)",
    drawer: "230ms cubic-bezier(.2, .8, .2, 1)"
  },
  zIndex: {
    sidebar: 1200,
    header: 1100,
    overlay: 1300
  }
};

export default adminTokens;
